package essntl.key

import androidx.compose.ui.input.key.KeyEvent
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class KeyEventManager {

    private val _events = MutableSharedFlow<KeyEvent>()
    val events = _events.asSharedFlow()

    suspend fun emitEvent(event: KeyEvent) {
        _events.emit(event)
    }

}